import { render, staticRenderFns } from "./EstablishmentForDisableFirstPartComp.vue?vue&type=template&id=51cc969b&scoped=true"
import script from "./EstablishmentForDisableFirstPartComp.vue?vue&type=script&lang=js"
export * from "./EstablishmentForDisableFirstPartComp.vue?vue&type=script&lang=js"
import style0 from "./EstablishmentForDisableFirstPartComp.vue?vue&type=style&index=0&id=51cc969b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cc969b",
  null
  
)

/* custom blocks */
import block0 from "./EstablishmentForDisableFirstPartComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports